<div class="card bg-white mb-3">
  <div class="p-3 border-bottom">
    <!-- Row 1: Title and Counters -->
    <div class="d-flex flex-row flex-wrap align-items-center gap-2 mb-3">
      <h1 class="h4 mb-0 me-md-2">Tender Suppliers</h1>
      <span class="badge bg-secondary" title="Total Companies">{{ getSupplierCount() }} Companies</span>
      <span class="badge bg-secondary" title="Total Users">{{ totalUsers }} Users</span>
    </div>

    <!-- Row 2: Filters and Actions -->
    <div class="d-flex flex-row flex-wrap align-items-center gap-2">
      <div class="ts-filter ts-filter--search">
        <jft-tender-suppliers-search-bar (onChanges)="search($event)"></jft-tender-suppliers-search-bar>
      </div>
      <div class="ts-filter">
        <ng-select [placeholder]="'Filter by tags...'" [items]="tags" multiple="true" bindLabel="name"
          (ngModelChange)="tagChange($event)" [(ngModel)]="selectedTags">
        </ng-select>
      </div>
      <div class="ts-filter">
        <ng-select [placeholder]="'Invitation Status...'" [items]="invitationStatusOptions" bindLabel="label"
          bindValue="value" [(ngModel)]="invitationStatus" (ngModelChange)="onInvitationStatusChange()">
        </ng-select>
      </div>
      <div class="ts-filter">
        <ng-select [placeholder]="'Bid Progress...'" [items]="bidProgressOptions" bindLabel="label" bindValue="value"
          [(ngModel)]="bidProgressFilter" (ngModelChange)="onBidProgressFilterChange()">
        </ng-select>
      </div>
      <div class="ts-filter">
        <ng-select [placeholder]="'Engagement...'" [items]="engagementOptions" bindLabel="label" bindValue="value"
          [(ngModel)]="engagementFilter" (ngModelChange)="onBidProgressFilterChange()">
        </ng-select>
      </div>
      <div class="btn-toolbar ms-lg-auto align-items-center flex-wrap gap-2">
        <a *ngIf="user.canManage(tender)" (click)="createSupplierManually()" href="javascript:void(0)" class="btn btn-light btn-sm me-3">
          <i class="ms-auto fas fa-plus"></i> New Supplier
        </a>
        <a *ngIf="user.canManage(tender)" (click)="addSuppliersFromContacts()" href="javascript:void(0)" class="btn btn-light btn-sm me-3">
          <i class="ms-auto fas fa-address-book"></i> From Contacts
        </a>
        <a *ngIf="user.canManage(tender)" (click)="reInviteSuppliersFromContacts()" href="javascript:void(0)" class="btn btn-light btn-sm me-3"
          ngbTooltip="Sends the tender invitation email again to contacts you select. Their existing bids are not affected."
          container="body">
          <i class="ms-auto fas fa-address-book"></i> Re-invite Contacts
        </a>

        <a (click)="downloadSuppliersTemplate($event)" href="javascript:void(0)" class="btn btn-light btn-sm">
          <i class="ms-auto fas fa-download"></i> Supplier List
        </a>
      </div>
    </div>
  </div>
  <div class="table-responsive d-none d-lg-block">
    <table class="table mb-0">
      <colgroup>
        <col span="1" style="width: 20%;">
        <col span="1" style="width: 14%;">
        <col span="1" style="width: 4%;">
        <col span="1" style="width: 62%;">
      </colgroup>
      <thead>
        <tr class="border-bottom">
          <th class="text-start">Company</th>
          <th class="text-start">Status</th>
          <th>

          </th>
          <th class="p-0">
            <table class="table mb-0">
              <colgroup>
                <col span="1" style="width: 20%;">
                <col span="1" style="width: 20%;">
                <col span="1" style="width: 20%;">
                <col span="1" style="width: 20%;">
                <col span="1" style="width: 20%;">
              </colgroup>
              <thead>
                <tr>
                  <th class="border-bottom-0 text-start">
                    Full Name
                  </th>
                  <th class="border-bottom-0 text-start">
                    Email
                  </th>
                  <th class="border-bottom-0 text-start">
                    Phone
                  </th>
                  <th class="border-bottom-0 text-start">
                    Tags
                  </th>
                  <th class="border-bottom-0">
                  </th>
                </tr>
              </thead>
            </table>
          </th>
        </tr>
      </thead>
      @for (company of suppliers; track company.id) {
      <tbody>
        <tr class="border-bottom border-primary">
          <td>
            <div class="td d-flex align-items-center">
              @if (company.logo) {
              <div class="avatar avatar-48 bg-white shadow me-3">
                <img class="p-2" src="{{ company.logo }}" alt="{{ company.name }}">
              </div>
              } @else {
              <div class="avatar avatar-48 bg-white shadow me-3 p-3">
                <svg fill="#c6c9d2" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 60 60" xml:space="preserve" stroke="#c6c9d2">
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                  <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                  <g id="SVGRepo_iconCarrier">
                    <g>
                      <path
                        d="M58,37.104V4c0-0.553-0.448-1-1-1H1C0.448,3,0,3.447,0,4v44c0,0.553,0.448,1,1,1h34.003c1.963,4.693,6.6,8,11.997,8 c7.168,0,13-5.832,13-13C60,41.465,59.26,39.105,58,37.104z M34.359,47H2V5h54v29.622c-0.17-0.164-0.354-0.311-0.532-0.465 c-0.088-0.075-0.171-0.155-0.261-0.228c-0.235-0.192-0.48-0.37-0.728-0.545c-0.092-0.065-0.181-0.135-0.275-0.198 c-0.245-0.163-0.498-0.312-0.754-0.458c-0.109-0.063-0.214-0.13-0.325-0.189c-0.077-0.041-0.154-0.083-0.232-0.123 c0.179-0.385,0.112-0.852-0.218-1.154l-12-11c-0.196-0.179-0.452-0.277-0.72-0.262c-0.265,0.012-0.515,0.129-0.694,0.325 l-9.794,10.727l-4.743-4.743c-0.374-0.373-0.972-0.391-1.368-0.044L6.339,41.249c-0.415,0.365-0.455,0.997-0.09,1.412 C6.447,42.886,6.723,43,7,43c0.234,0,0.47-0.082,0.66-0.249l16.313-14.362l10.302,10.301c0.203,0.203,0.47,0.295,0.736,0.287 C34.361,40.523,34,42.22,34,44c0,0.493,0.033,0.977,0.087,1.456c0.009,0.075,0.024,0.149,0.034,0.224 c0.056,0.428,0.131,0.849,0.227,1.262C34.353,46.961,34.354,46.981,34.359,47z M48.779,31.136 c-0.162-0.022-0.321-0.055-0.485-0.071C47.867,31.023,47.435,31,47,31c-4.773,0-8.942,2.593-11.203,6.437 c-0.036-0.054-0.06-0.114-0.107-0.162l-4.807-4.807l9.181-10.054l9.694,8.887c-0.067-0.015-0.133-0.032-0.2-0.045 C49.301,31.204,49.039,31.172,48.779,31.136z M47,55c-4.787,0-8.859-3.08-10.367-7.358c-0.094-0.267-0.176-0.536-0.249-0.806 c-0.015-0.058-0.03-0.115-0.045-0.173c-0.06-0.238-0.112-0.476-0.156-0.716c-0.024-0.133-0.042-0.267-0.061-0.401 c-0.026-0.18-0.054-0.36-0.071-0.54C36.021,44.674,36,44.339,36,44c0-6.065,4.935-11,11-11c0.426,0,0.848,0.031,1.265,0.079 c0.127,0.015,0.25,0.039,0.375,0.057c0.291,0.044,0.579,0.096,0.863,0.162c0.141,0.033,0.281,0.07,0.421,0.108 c0.268,0.074,0.531,0.159,0.792,0.253c0.134,0.048,0.269,0.094,0.4,0.147c0.295,0.119,0.583,0.255,0.866,0.399 c0.083,0.042,0.17,0.077,0.252,0.121c0.342,0.185,0.671,0.393,0.992,0.614c0.131,0.09,0.255,0.19,0.382,0.286 c0.199,0.15,0.395,0.305,0.584,0.469c0.127,0.11,0.251,0.224,0.373,0.339c0.193,0.184,0.379,0.377,0.559,0.575 c0.094,0.103,0.191,0.202,0.281,0.309c0.261,0.311,0.51,0.634,0.739,0.976C57.315,39.643,58,41.743,58,44 C58,50.065,53.065,55,47,55z">
                      </path>
                      <path
                        d="M51.95,39.051c-0.391-0.391-1.023-0.391-1.414,0L47,42.586l-3.536-3.535c-0.391-0.391-1.023-0.391-1.414,0 s-0.391,1.023,0,1.414L45.586,44l-3.536,3.535c-0.391,0.391-0.391,1.023,0,1.414c0.195,0.195,0.451,0.293,0.707,0.293 s0.512-0.098,0.707-0.293L47,45.414l3.536,3.535c0.195,0.195,0.451,0.293,0.707,0.293s0.512-0.098,0.707-0.293 c0.391-0.391,0.391-1.023,0-1.414L48.414,44l3.536-3.535C52.34,40.074,52.34,39.441,51.95,39.051z">
                      </path>
                      <path
                        d="M16,25.138c3.071,0,5.569-2.498,5.569-5.568C21.569,16.498,19.071,14,16,14s-5.569,2.498-5.569,5.569 C10.431,22.64,12.929,25.138,16,25.138z M16,16c1.968,0,3.569,1.602,3.569,3.569S17.968,23.138,16,23.138s-3.569-1.601-3.569-3.568 S14.032,16,16,16z">
                      </path>
                    </g>
                  </g>
                </svg>
              </div>
              }
              {{ company.name }}
              @if (company.supplierAlias) {
              <span class="text-muted small ms-1">({{ company.supplierAlias }})</span>
              }
            </div>
          </td>
          <td>
            @if (company.invitationStatus) {
            <div class="badge mb-1 d-block text-start" [ngClass]="{
                   'bg-success-subtle text-success': company.invitationStatus === 'Accepted',
                   'bg-warning-subtle text-warning': company.invitationStatus === 'Pending',
                   'bg-danger-subtle text-danger': company.invitationStatus === 'Declined',
                   'bg-secondary-subtle text-secondary': company.invitationStatus === 'Expired'
                 }">
              <i class="fas fa-fw me-1" [ngClass]="{
                'fa-check-circle': company.invitationStatus === 'Accepted',
                'fa-clock': company.invitationStatus === 'Pending',
                'fa-times-circle': company.invitationStatus === 'Declined',
                'fa-hourglass-end': company.invitationStatus === 'Expired'
              }"></i>Invitation {{ company.invitationStatus }}
            </div>
            }
            @if (company.roundProgress && company.roundProgress.length > 0) {
            <div class="mt-1">
              @for (rp of company.roundProgress; track rp.round) {
              <div class="d-flex align-items-center mb-1 flex-wrap">
                <span class="text-muted small me-1" style="min-width: 24px;">R{{ rp.round }}</span>
                @for (entry of rp.counts; track entry.bucket) {
                <span class="badge badge-sm me-1" [ngClass]="chipClass(entry.bucket)">
                  {{ entry.count }} {{ chipLabel(entry.bucket) }}
                </span>
                }
                @if (rp.counts.length === 0) {
                <span class="badge badge-sm bg-secondary-subtle text-secondary">Not invited</span>
                }
              </div>
              }
            </div>
            }
          </td>
          <td class="text-end">
            <div ngbDropdown class="d-inline-block">
              <button type="button" class="btn btn-sm row-actions-btn" ngbDropdownToggle>
                <i class="fas fa-ellipsis-v"></i>
              </button>
              <div ngbDropdownMenu>
                <h6 class="dropdown-header">Company Actions</h6>
                <button *ngIf="user.canManage(tender)" ngbDropdownItem (click)="confirmSendInvitation(company)">
                  <i class="fas fa-envelope me-2 text-muted"></i> Re-send Invitation
                </button>
                <button *ngIf="user.canManage(tender)" ngbDropdownItem (click)="confirmSendSupplierReminder(company)">
                  <i class="fas fa-bell me-2 text-muted"></i> Send Reminder
                </button>
                <div class="dropdown-divider"></div>
                @if (canAccessManualBidInput()) {
                <a ngbDropdownItem
                  [routerLink]="['/tenders', $safeNavigationMigration(tender?.id), 'supplier', $safeNavigationMigration(company?.id), 'input-bid', 'flow']">
                  <i class="fas fa-keyboard me-2 text-muted"></i> Manual Bid Input
                </a>
                } @else {
                <button ngbDropdownItem disabled [ngbTooltip]="getManualBidInputRestrictionTooltip()" placement="end">
                  <i class="fas fa-keyboard me-2 text-muted"></i> Manual Bid Input
                </button>
                }
              </div>
            </div>
          </td>
          <td class="border-start p-0">
            <table class="w-100 mb-0">
              <colgroup>
                <col span="1" style="width: 20%;">
                <col span="1" style="width: 20%;">
                <col span="1" style="width: 20%;">
                <col span="1" style="width: 20%;">
                <col span="1" style="width: 20%;">
              </colgroup>
              <tbody>
                @for (us of company.users; track us.id) {
                <tr class="table-inner">
                  <td class="py-2 ps-2">
                    @if (us?.is_active) {
                    <i class="fas fa-user-check me-2" placement="left"
                      ngbTooltip="Active supplier on JetFuelTenders.com"></i>
                    } @else {
                    <i class="fas fa-user-times me-2" placement="left"
                      ngbTooltip="This user hasn't yet activated their JetFuelTenders.com account"></i>
                    }
                    {{ us?.lastName }} {{ us?.firstName }}
                  </td>
                  <td class="py-2">
                    <div class="d-flex align-items-center">
                      {{ us?.email }}
                    </div>
                  </td>
                  <td class="py-2">
                    {{ us?.phone }}
                  </td>
                  <td class="py-2">
                    @for (tag of us.tags; track tag.id) {
                    <span
                      class="badge py-1 px-2 me-3 text-warning-emphasis bg-warning-subtle border border-warning-subtle rounded-pill">
                      {{tag['name']}}
                    </span>
                    }
                  </td>
                  <td class="py-2 pe-2 text-end">
                    <div ngbDropdown class="d-inline-block">
                      <button type="button" class="btn btn-sm row-actions-btn" ngbDropdownToggle>
                        <i class="fas fa-ellipsis-v"></i>
                      </button>
                      <div ngbDropdownMenu>
                        <h6 class="dropdown-header">User Actions</h6>
                        <button *ngIf="user.canManage(tender)" ngbDropdownItem (click)="confirmSendInvitationToUser(company, us)">
                          <i class="fas fa-envelope me-2 text-muted"></i> Re-send Invitation
                        </button>
                        <button ngbDropdownItem (click)="getInvitationSupplierInfo(company, us)">
                          <i class="fas fa-eye me-2 text-muted"></i> View Invite
                        </button>
                        <div class="dropdown-divider"></div>
                        <button *ngIf="user.canManage(tender)" ngbDropdownItem class="text-danger" (click)="confirmRemoveUser(company, us)">
                          <i class="fas fa-user-minus me-2"></i> Revoke Tender Invitation
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>
                }
                @if (suppliers.length == 0) {
                <tr>
                  <td colspan="3">No users</td>
                </tr>
                }
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
      }
      @if (!suppliers.length) {
      <tbody>
        <tr>
          <td colspan="7">
            <p class="text-center mt-5">No suppliers found</p>
          </td>
        </tr>
      </tbody>
      }
    </table>
  </div>

  <!-- Mobile card view (shown < lg) -->
  <div class="d-lg-none supplier-cards p-2">
    @for (company of suppliers; track company.id) {
    <div class="s-group">
      <div class="s-group__head">
        <div class="avatar avatar-32 border bg-white p-1">
          @if (company.logo) {
          <img [src]="company.logo" [alt]="company.name">
          } @else {
          <i class="fas fa-building text-muted"></i>
          }
        </div>
        <div class="s-group__id">
          <div class="s-group__name">
            {{ company.name }}
            @if (company.supplierAlias) {
            <span class="text-muted small">({{ company.supplierAlias }})</span>
            }
          </div>
          <div class="s-group__meta">
            {{ company.users.length }} {{ company.users.length === 1 ? 'contact' : 'contacts' }}
          </div>
        </div>
        <div ngbDropdown placement="bottom-end">
          <button type="button" class="btn btn-sm row-actions-btn" ngbDropdownToggle>
            <i class="fas fa-ellipsis-v"></i>
          </button>
          <div ngbDropdownMenu>
            <h6 class="dropdown-header">Company Actions</h6>
            <button *ngIf="user.canManage(tender)" ngbDropdownItem (click)="confirmSendInvitation(company)">
              <i class="fas fa-envelope me-2 text-muted"></i> Re-send Invitation
            </button>
            <button *ngIf="user.canManage(tender)" ngbDropdownItem (click)="confirmSendSupplierReminder(company)">
              <i class="fas fa-bell me-2 text-muted"></i> Send Reminder
            </button>
            <div class="dropdown-divider"></div>
            @if (canAccessManualBidInput()) {
            <a ngbDropdownItem [routerLink]="['/tenders', $safeNavigationMigration(tender?.id), 'supplier', $safeNavigationMigration(company?.id), 'input-bid', 'flow']">
              <i class="fas fa-keyboard me-2 text-muted"></i> Manual Bid Input
            </a>
            } @else {
            <button ngbDropdownItem disabled [ngbTooltip]="getManualBidInputRestrictionTooltip()" placement="end">
              <i class="fas fa-keyboard me-2 text-muted"></i> Manual Bid Input
            </button>
            }
          </div>
        </div>
      </div>

      @if (company.invitationStatus || (company.roundProgress && company.roundProgress.length > 0)) {
      <div class="s-group__status">
        @if (company.invitationStatus) {
        <span class="badge" [ngClass]="{
                'bg-success-subtle text-success': company.invitationStatus === 'Accepted',
                'bg-warning-subtle text-warning': company.invitationStatus === 'Pending',
                'bg-danger-subtle text-danger': company.invitationStatus === 'Declined',
                'bg-secondary-subtle text-secondary': company.invitationStatus === 'Expired'
              }">
          <i class="fas fa-fw me-1" [ngClass]="{
              'fa-check-circle': company.invitationStatus === 'Accepted',
              'fa-clock': company.invitationStatus === 'Pending',
              'fa-times-circle': company.invitationStatus === 'Declined',
              'fa-hourglass-end': company.invitationStatus === 'Expired'
            }"></i>Invitation {{ company.invitationStatus }}
        </span>
        }
        @for (rp of company.roundProgress; track rp.round) {
        @for (entry of rp.counts; track entry.bucket) {
        <span class="badge me-1" [ngClass]="chipClass(entry.bucket)">
          R{{ rp.round }}: {{ entry.count }} {{ chipLabel(entry.bucket) }}
        </span>
        }
        @if (rp.counts.length === 0) {
        <span class="badge me-1 bg-secondary-subtle text-secondary">R{{ rp.round }}: Not invited</span>
        }
        }
      </div>
      }

      @for (us of company.users; track us.id) {
      <div class="s-contact">
        <div class="s-contact__body">
          <div class="s-contact__name">
            @if (us?.is_active) {
            <i class="fas fa-user-check text-success" ngbTooltip="Active supplier on JetFuelTenders.com"></i>
            } @else {
            <i class="fas fa-user-times text-muted"
              ngbTooltip="This user hasn't yet activated their JetFuelTenders.com account"></i>
            }
            {{ us?.firstName }} {{ us?.lastName }}
          </div>
          <a class="s-contact__line" [href]="'mailto:' + $safeNavigationMigration(us?.email)">{{ us?.email }}</a>
          <div class="s-contact__line" *ngIf="us?.phone">{{ us?.phone }}</div>
          <div class="s-contact__tags" *ngIf="us.tags?.length">
            @for (tag of us.tags; track tag.id) {
            <span class="badge py-1 px-2 me-1 text-warning-emphasis bg-warning-subtle border border-warning-subtle rounded-pill">
              {{ tag['name'] }}
            </span>
            }
          </div>
        </div>
        <div ngbDropdown placement="bottom-end" class="s-contact__actions">
          <button type="button" class="btn btn-sm row-actions-btn" ngbDropdownToggle>
            <i class="fas fa-ellipsis-v"></i>
          </button>
          <div ngbDropdownMenu>
            <h6 class="dropdown-header">User Actions</h6>
            <button *ngIf="user.canManage(tender)" ngbDropdownItem (click)="confirmSendInvitationToUser(company, us)">
              <i class="fas fa-envelope me-2 text-muted"></i> Re-send Invitation
            </button>
            <button ngbDropdownItem (click)="getInvitationSupplierInfo(company, us)">
              <i class="fas fa-eye me-2 text-muted"></i> View Invite
            </button>
            <div class="dropdown-divider"></div>
            <button *ngIf="user.canManage(tender)" ngbDropdownItem class="text-danger" (click)="confirmRemoveUser(company, us)">
              <i class="fas fa-user-minus me-2"></i> Revoke Tender Invitation
            </button>
          </div>
        </div>
      </div>
      }
    </div>
    }
    @if (!suppliers.length) {
    <p class="text-center small my-5 text-muted">No suppliers found</p>
    }
  </div>

  <div class="d-flex justify-content-center pt-3 pb-3" *ngIf="suppliers.length < totalItems">
    <button class="btn btn-primary" (click)="loadMore()" [disabled]="loadingMore">
      <span *ngIf="loadingMore" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
      Load More
    </button>
  </div>
</div>